import React, { Component } from "react";
import {
    DKLabel,
    DKLine,
    showLoader,
    removeLoader,
    INPUT_VIEW_DIRECTION
} from "deskera-ui-library";
import moment from 'moment'

import DataGridUtility from "../../utility/DataGridUtility";
import CustomInput from "../../SharedComponents/CustomInput/CustomInput";
import { INPUT_TYPE, payDayMonthly } from "../../constants/Constant";
import {TENANT, TenantService} from "../../managers/TenantManagerService"
import PayScheduleService from "../../services/PayScheduleService";
import { PayScheduleManager } from "../../managers/PayScheduleManager";

export default class PaySchedule extends Component {
    constructor(props){
        super(props)
        this.state = {
            formFields: []
        }
    }
    direction = INPUT_VIEW_DIRECTION.VERTICAL
    defaultValues = {
        firstPayDate: moment().endOf('month').format("YYYY-MM-DD"),
        workWeek:[1,2,3,4,5],
        payDay: 'lastWorkingDayMonth',
        payPeriod: 'monthly'

    };
    columns = [{
        columnCode: "name",
        autoFocus: true,
        editable: true,
        hidden: false,
        id: "BF1x",
        index: 0,
        name: "Schedule Name",
        options: null,
        required: true,
        systemField: true,
        type: "text",
        uiVisible: true,
        width: 300
    },
    {
        columnCode: "payPeriod",
        editable: true,
        hidden: false,
        id: "BF0y",
        index: 0,
        name: "Pay Period",
        options: [{label:'Monthly', value:'monthly'}],
        required: true,
        systemField: true,
        type: "select",
        uiVisible: true,
        width: 300
    },
    {
        columnCode: "workWeek",
        editable: true,
        hidden: false,
        id: "BF0x",
        index: 0,
        name: "Work week",
        options: TenantService.get(TENANT.TENANT_WORK_WEEK).map(e=>{return {label:e.day.charAt(0).toUpperCase() +e.day.substr(1).toLowerCase(), value:e.day}}),
        required: true,
        systemField: true,
        type: INPUT_TYPE.MULTI_SELECT,
        uiVisible: true,
        width: 300
    },
    {
        columnCode: "payDay",
        editable: true,
        hidden: false,
        id: "BF1y",
        index: 0,
        name: "Pay Day",
        options: payDayMonthly.map(e=> { return {label: e.name, value: e.id} }),
        required: true,
        systemField: true,
        type: "select",
        uiVisible: true,
        width: 300
    },
    {
        columnCode: "firstPayDate",
        editable: true,
        hidden: false,
        id: "BF2y",
        index: 0,
        name: "First Pay Date",
        options: null,
        required: true,
        systemField: true,
        type: "date",
        uiVisible: true,
        width: 300
    }
    ];
    componentDidMount() {
        showLoader()
        PayScheduleService.getPaySchedule()
            .then((responseData) => {
                removeLoader()
                if(responseData['schedules']) {
                    this.defaultValues = (responseData['schedules'].length != 0) ? responseData['schedules'][0] : this.defaultValues ;
                    this.defaultValues['firstPayDate'] = moment(this.defaultValues['firstPayDate']).format('YYYY-MM-DD');
                }
                this.buildForm();
            })
    }
    buildForm = () => {
        this.processDataForForm()
        this.putAdditionalFields().then(() => {
            let formFields = DataGridUtility.getFormElementsByKey(
                this.columns,
                this.defaultValues
            );
            this.setState({
                formFields
            });
            this.props.setData(this.defaultValues, this.isValidFormDetail());
        });
    }
    processDataForForm = () => {
        this.columns.forEach(column => {
            column['key'] = column.columnCode;
        });
    }
    putAdditionalFields = () => {
        return Promise.resolve();
    };
    render() {
        return (
            <div className={`column parent-width`}>

                <div className="bg-white border-radius-s card-shadow parent-width ">
                    <DKLabel text="Pay Schedule" className="fw-m fs-l mb-r pt-l p-h-l" />
                    <DKLine className="bg-line-2" />
                    <div style={{
                        display: 'flex',
                        flexWrap: 'wrap'
                    }} className=" parent-width mb-s mt-l">

                        {this.state.formFields && this.getFormFields()}
                    </div>
                </div>
            </div>
        )
    }
    getFormFields() {
        let fields = this.state.formFields.map((obj, index) => {
            return (

                <div className="" style={{
                    flex: "0 0 50%",
                    maxWidth: "50%"
                }}
                    key={obj.id}>
                    <div className="m-h-l">
                    <CustomInput
                        autoFocus={index === 0 && this.props.autoFocus === true}
                        className={"p-v-s p-h-l"}
                        icon={obj.icon}
                        labelName={obj.name}
                        placeholder={obj.name}
                        defaultValue={obj.value}
                        options={obj.options}
                        type={obj.type}
                        hasError={obj.hasError}
                        errorMsg={obj.errorMsg}
                        readOnly={!obj.editable}
                        labelClassName=" text-align-left "
                        canValidate={this.state.canValidate}
                        onChange={(value) => {
                            this.onChange(value, index)
                        }}
                        direction={this.direction}
                        isRequired={obj.required}
                        isDisabled={!obj.editable}
                        dateFormat={this.props.dateFormat}
                        readOnly={this.props.readOnly}
                        onClick={() => {

                            if (index === this.state.formFields.length - 1) {
                                this.scrollToBottom();
                            }
                        }}
                    />
                    </div>
                </div>
            )
        })
        return fields;
    }
    onChange(value, index) {

        let data = this.state.formFields[index];
        if(data && data['type'] != INPUT_TYPE.MULTI_SELECT) {
            data["value"] = value.target ? value.target.value : value['value'];
        } else {
            data["value"] = value;
        }

        switch (data['columnCode']) {
            case "payDay":
                let firstPayField = this.state.formFields[index+1];
                if(data["value"] == "lastWorkingDayMonth") {
                    firstPayField["value"] = moment().endOf('month').format("YYYY-MM-DD")
                } else {
                    firstPayField["value"] = moment().format(`YYYY-MM-${(data["value"] < 10 ? "0"+data["value"] : data["value"] )}`)
                }
            case "workWeek":
                if(data["value"]) {
                    this.state.formFields[index].hasError = (data['value'].length ==0) ? true : false;
                    this.state.formFields[index].errorMsg = "Please select work week days";
                }
                break;
            default:
                if (this.state.formFields[index].required) {
                    this.state.formFields[index].hasError = (data["value"].trim() == "") ? true : false;
                    this.state.formFields[index].errorMsg = "Field cannot be empty";
                }
                break;
        }
        this.setState({
            formFields:this.state.formFields
        })
        let { finalData, isValid } = PayScheduleManager.processDataForSubmit(data, this.defaultValues);
        this.props.setData(finalData, this.isValidFormDetail());
    }
    scrollToBottom(){

    }
    isValidFormDetail() {
        let isValid = true;
        this.state.formFields.forEach(field => {
            if(field.hasError || (field.required && (!field.value && field.value != 0)))  {
                isValid = false;
            }
        })
        return isValid;
    }
    showAlert() {
        this.state.formFields.forEach((field,index)=>{
            this.showInvalidField(field,index)
        })
    }
    showInvalidField(value,index){
        
        let data = this.state.formFields[index];
        if(typeof data.value == "number" && data.value == 0) {
            // do later
        } else {
            data["value"] =  (value['value'] ? value['value']:"");
        }

        switch (data['columnCode']) {
            case "payDay":
                let firstPayField = this.state.formFields[index+1];
                if(data["value"] == "lastWorkingDayMonth") {
                    firstPayField["value"] = moment().endOf('month').format("YYYY-MM-DD")
                } else {
                    firstPayField["value"] = moment().format(`YYYY-MM-${(data["value"] < 10 ? "0"+data["value"] : data["value"] )}`)
                }
            case "workWeek":
                if(data["value"]) {
                    this.state.formFields[index].hasError = (data['value'].length ==0) ? true : false;
                    this.state.formFields[index].errorMsg = "Please select work week days";
                }
                break;
            default:
                if (this.state.formFields[index].required) {
                    let field = this.state.formFields[index]
                    if((field.hasError || field.required)&& typeof field.value == "number" && field.value == 0) {
                        // do later
                    } else
                    if (field.hasError || (field.required && ((field.value&&field.value.toString()) =='') || typeof field.value == undefined )) {
                        this.state.formFields[index].hasError = (data['value'].trim() == "") ? true : false;
                        this.state.formFields[index].errorMsg = "Field cannot be empty";
                    }
                }
                break;
        }
        this.setState({
            formFields: this.state.formFields
        });
    }
}